import {createApp} from 'vue'
import i18n from './localization/i18n'
import App from './App.vue'
import store from './store/Store';
import './filters/translate';
import './filters/firstUpper';
import './filters/localized';
import './filters/noname';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, md } from 'vuetify/iconsets/md'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import moment from 'moment-timezone';
import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'
import LeavePrevent from "./services/LeavePrevent";
import Auth from "./plugins/auth";
import ConnectionMonitor from './services/ConnectionMonitor';
import { initFirebase } from './services/firebase/firebase';
import {initApiErrorHandling} from "@/services/api/error-handler";
import router from "./router";
import QuerySynchronizer from "@oarepo/vue-query-synchronizer";
// VNumberInput sits in labs up to Vuetify 3.12 and in the stable barrel from 3.13 on.
// The Docker image installs from package.json instead of the lockfile, so the built
// image can end up on either side of that move - register whichever one has it.
import {VNumberInput} from "vuetify/labs/components";

let detectedLocale = (window.navigator.language || 'cs').slice(0, 2);
if (detectedLocale === 'cs') detectedLocale = 'cz';
console.log('locale ', detectedLocale)
moment.locale(detectedLocale === 'cz' ? 'cs' : detectedLocale);
moment.tz.setDefault('Europe/Prague');
i18n.global.locale.value = detectedLocale;

// init monitoring of internet connection
ConnectionMonitor.init();

// init prevention of leaving without saving changes
LeavePrevent.init();

// init Firebase
initFirebase();

// init Vuetify
const vuetify = createVuetify({
  components: {
    ...components,
    ...(VNumberInput ? {VNumberInput} : {}),
  },
  directives,
  theme: {
    defaultTheme: 'myMendeluTheme',
    themes: {
      myMendeluTheme: {
        dark: false,
        colors: {
          background: '#FFFFFF',
          surface: '#FFFFFF',
          primary: '#78BE13',
          'primary-darken-1': '#55860e',
          secondary: '#7c7c7c',
          'secondary-darken-1': '#444444',
          error: '#B00020',
          info: '#7ccef1',
          success: '#4CAF50',
          warning: '#FB8C00',
        }
      }
    }
  },
  icons: {
    defaultSet: 'md',
    aliases,
    sets: {
      md,
    },
  },
})


// init Vue
const app = createApp({
  i18n,
  ...App
})

// init API error handling
initApiErrorHandling(app);

// init extensions
app.use(store)
app.use(Auth, {store});
app.use(i18n)
app.use(vuetify)
app.use(router)
app.use(QuerySynchronizer, {
  router: router,
  navigationOperation: 'replace',
})

app.component(VueQrcode.name, VueQrcode);

app.mount('#app')


// --- TEST ENVIRONMENT ---
// https://www.cypress.io/blog/2017/11/28/testing-vue-web-application-with-vuex-data-store-and-rest-backend/#ui-to-store
// https://stackoverflow.com/questions/62297240/access-data-model-in-vuejs-with-cypress-application-actions
// Only available during E2E tests
if (window.Cypress) {

  // Allow tests to access the app instance.
  window.app = app;
  window.app.$router = router;

  // Disable all transitions to speed up tests and prevent necessary waiting for elements to be visible.
  // The general `*` is not working for all Vuetify components because some components like expansion panels have !important too.
  // Hence, we must turn off transitions for these specific components using precise selectors to override also !importants from Vuetify.
  const testStyles = document.createElement("style")
  testStyles.textContent = `
    *,
    *:before,
    *:after,
    .v-item-group.v-expansion-panels,
    .v-item-group.v-expansion-panels .v-expansion-panel,
    .v-item-group.v-expansion-panels .v-expansion-panel-title,
    .v-item-group.v-expansion-panels .v-expansion-panel-text {
        transition: none !important;
    }`;
  document.head.appendChild(testStyles);
}
